export default "__VITE_ASSET__cbe67cc2__"